import { rpcSpecification } from "#root/bin/server/client/ep/endpoints";
import { adminRpcSpec } from "#root/bin/server/client/ep/endpointsAdmin";
import { makeClientEndpoints } from "#root/bin/server/client/types";

export const endpoints = makeClientEndpoints({
  ...rpcSpecification,
  ...adminRpcSpec,
});
